import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { report } from '../../../../models/report';
import { from } from 'rxjs';
import { groupBy, mergeMap, toArray, reduce } from 'rxjs/operators';
import { TravelService } from 'src/app/services/travel.service';
import { GasTravel } from 'src/app/models/gas-travel';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-proeco-report',
  templateUrl: './proeco-report.component.html',
  styleUrls: ['./proeco-report.component.css'],
  providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }]
})
export class ProecoReportComponent implements OnInit {

  date1: Date = new Date();
  date2: Date = new Date();
  loading: boolean = false;
  data: any[] = [];
  pivot: any[] = [];
  id_unidad_filter: number[] = [];
  combustible_filter: number[] = [];
  unidadesCollection: number[];
  combustibleCollection: number[];
  originalCollection: any[];
  expand: boolean = false;
  total_gas: number = 0;
  total_gas_real: number = 0;
  total_gas_proeco: number = 0;
  total_gas_t26: number = 0;
  id_unidad: number = 0;
  combustible: number = 0;
  gasTravel:GasTravel = new GasTravel();

  constructor(private reportServ: ReportService, private travelServ:TravelService, private toastr:ToastrManager, private modalService: NgbModal) { }

  ngOnInit() {
  }

  search() {
    this.loading = true;
    this.reportServ.proecoReport(this.date1, this.date2)
      .then(resp => {
        this.data = resp;
        this.pivot = resp;
        this.originalCollection = resp;
        this.unidadesCollection = this.clean(resp, "unity_id");
        this.combustibleCollection = this.clean(resp, "type");
        this.loading = false;
        this.id_unidad_filter = [];
        this.combustible_filter = [];
        this.total_gas_real = this.sumField(this.data, 'gas_real');
        this.total_gas_proeco = this.sumFieldWithCondition(this.data, 'type', 'proeco', 'gas_real');
        this.total_gas_t26 = this.sumFieldWithCondition(this.data, 'type', 't26', 'gas_real');

        from(this.data)
          .pipe(
            groupBy(x => x.id),
            mergeMap(toArray()),
            reduce((x, y) => x + Number(y[0].gas), 0)
          ).subscribe(x => this.total_gas = Number(x));
      });
  }

  addElement(element, whoArray) {
    if (whoArray.indexOf(element) === -1) {
      whoArray.push(element);
      this.searchAdvanced();
    }
  }

  clean(array: report[], key: string) {
    let a = [];
    array.map(x => {
      if (!a.includes(x[key])) {
        a.push(x[key]);
      }
    });
    return a;
  };

  removeElement(element: string, whoArray: Array<string>) {
    for (var i = 0; i < whoArray.length; i++) {
      if (whoArray[i] === element) {
        whoArray.splice(i, 1);
      }
    }
    this.searchAdvanced();
  }

  sumField(ax: report[], key: string): number {
    var sum = 0;
    ax.map(x => { sum = sum + Number(x[key]); });
    return sum;
  }

  sumFieldWithCondition(ax: report[], key: string, condition: string, field: string): number {
    var sum = 0;
    ax.map(x => {
      if (x[key].toLocaleLowerCase() == condition) {
        sum = sum + Number(x[field]);
      }
    });
    return sum;
  }

  searchAdvanced() {
    var tmp = [];
    if (this.id_unidad_filter.length != 0 || this.combustible_filter.length != 0) {
      if (this.id_unidad_filter.length == 0) {
        this.data = this.filterData(this.pivot, 'type', this.combustible_filter);
      }
      if (this.combustible_filter.length == 0) {
        this.data = this.filterData(this.pivot, 'unity_id', this.id_unidad_filter);
      }
      if (this.id_unidad_filter.length > 0 && this.combustible_filter.length > 0) {
        var a = this.filterData(this.pivot, 'unity_id', this.id_unidad_filter);
        this.data = this.filterData(a, 'type', this.combustible_filter);
      }
    } else {
      this.data = this.originalCollection;
    }
    this.total_gas_real = this.sumField(this.data, 'gas_real');
    this.total_gas_proeco = this.sumFieldWithCondition(this.data, 'type', 'proeco', 'gas_real');
    this.total_gas_t26 = this.sumFieldWithCondition(this.data, 'type', 't26', 'gas_real');
  }

  filterData(ax, key, filter) {
    var result = [];
    ax.map(x => {
      filter.map(y => {
        x[key] == y ? result.push(x) : '';
      });
    });
    return result;
  }

  download(type) {
    window.open(environment.baseUrl + '/' + type + '/proeco?date1=' + this.date1.toString() + '&date2=' + this.date2.toString() + '&unidades=' + this.id_unidad_filter + "&types=" + this.combustible_filter, '_blank')
  }

  openModal(modal){
    this.modalService.open(modal, { size: 'lg', centered: true });
  }

  deleteGasTravel(){
    if (!this.gasTravel.sap_code) {
      this.loading = true;
      this.travelServ.deleteGasTravel(this.gasTravel).subscribe(resp=>{
        this.data = this.data.filter(d => d.gas_travel_id != this.gasTravel.id);
        this.gasTravel.id = 0;
        this.gasTravel.gasticket = 0;
        this.toastr.successToastr("Viaje eliminado correctamente.");
        this.modalService.dismissAll();
        this.loading = false;
      },error=>{
        this.toastr.errorToastr("No se pudo eliminar el viaje.");
        console.log(error);
        this.loading = false;
      });
    } else {
      this.toastr.infoToastr("Ya sea ha cargado a SAP, es imposible eliminarlo, verificalo con el juanito.");
    }
  }

}
